import { plural } from '@cian/utils';
export var getTextCount = function getTextCount(count) {
  return count ? "".concat(count, " ").concat(plural(count, ['подборку', 'подборки', 'подборок'])) : 'Нет подборок';
};